import { baseUniDriverFactory } from '../utils/test-utils/unidriver';

export const transitionDriverFactory = base => {
  const { element, exists } = baseUniDriverFactory(base);
  return {
    exists,
    element,
  };
};
